var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":true,"background-color":"#000","color":"#068bcd","opacity":0.5,"width":70,"height":70},on:{"update:active":function($event){_vm.isLoading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }